import classNames from "classnames";
import styles from "./styles.module.scss";

export default function Spinner({ text }) {
  return (
    <div className={classNames("w-full h-full ")}>
      <div className={classNames("w-full h-full absolute top-0 left-0 opacity-50 bg-white ")}></div>
      <div className="w-full h-full flex  absolute top-0 left-0 flex-col justify-center items-center">
        <div className={classNames(styles.loader)}></div>
        <p className="text-sm mt-1">{text}</p>
      </div>
    </div>
  );
}
